import { createRouter, createWebHashHistory } from "vue-router";
import type { RouteRecordRaw } from "vue-router";
import type { App } from "vue";
import { Layout } from "@/utils/routerHelper";
import { useI18n } from "@/hooks/web/useI18n";

const { t } = useI18n();

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    name: "Root",
    meta: {
      hidden: true,
    },
  },
  {
    path: "/redirect",
    component: Layout,
    name: "Redirect",
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "RedirectChild",
        component: () => import("@/views/Redirect/Redirect.vue"),
        meta: {},
      },
    ],
    meta: {
      hidden: true,
      noTagsView: true,
    },
  },
  {
    path: "/login",
    component: () => import("@/views/Login/Login.vue"),
    name: "Login",
    meta: {
      hidden: true,
      title: t("router.login"),
      noTagsView: true,
    },
  },
  {
    path: "/404",
    component: () => import("@/views/Error/404.vue"),
    name: "NoFind",
    meta: {
      hidden: true,
      title: "404",
      noTagsView: true,
    },
  },
  // Self-service account access requires login, not a role menu grant.
  {
    path: "/system/my-account",
    component: Layout,
    name: "SelfServiceAccount",
    meta: {
      hidden: true,
    },
    children: [
      {
        path: "",
        name: "SelfServiceAccountIndex",
        component: () => import("@/views/UserManagement/MyAccount/index.vue"),
        meta: {
          hidden: true,
          title: "router.myAccount",
        },
      },
    ],
  },
  // Business Intelligence is now supplied by the authorized System menu.
  /*
  {
    path: "/business-intelligence",
    component: Layout,
    name: "BusinessIntelligence",
    children: [
      {
        path: "",
        name: "BusinessIntelligenceIndex",
        component: () => import("@/views/DataScreen/index.vue"),
        meta: {
          hidden: true,
          title: "Business Intelligence",
          icon: "ep:data-board",
        },
      },
    ],
    meta: {
      hidden: true,
      title: "Business Intelligence",
      icon: "ep:data-board",
    },
  },
  */
  {
    path: "/data-screen",
    component: () => import("@/views/DataScreen/index.vue"),
    name: "DataScreen",
    meta: {
      hidden: true,
      title: "Data Screen",
      noTagsView: true,
    },
  },
  {
    path: "/demo",
    component: Layout,
    name: "Demo",
    meta: {
      hidden: true,
      noTagsView: true,
    },
    children: [
      {
        path: "receipt",
        name: "DemoReceipt",
        component: () => import("@/views/Demo/receipt.vue"),
        meta: {
          hidden: true,
          title: "Receipt Demo",
          noTagsView: true,
        },
      },
    ],
  },
];

export const asyncRouterMap: AppRouteRecordRaw[] = [];

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 }),
});

export const resetRouter = (): void => {
  const resetWhiteNameList = [
    "Redirect",
    "Login",
    "NoFind",
    "Root",
    "SelfServiceAccount",
    "SelfServiceAccountIndex",
    // "BusinessIntelligence",
    // "BusinessIntelligenceIndex",
    "DataScreen",
  ];
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name);
    }
  });
};

export const setupRouter = (app: App<Element>) => {
  app.use(router);
};

export default router;
